module.exports = __webpack_public_path__ + "img/about_img.72f06b88.png";